module.exports = new __parcel__URL__("Mageskill_50.31ea2932.png").toString();